var _g, _defs;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgGroup = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90033 19.0169C4.78366 19.0169 4.66699 18.9002 4.66699 18.7835V18.5502C4.66699 17.9669 5.01699 17.3835 5.60033 17.0335L7.23366 15.9835C7.46699 15.8669 7.70033 15.6335 7.70033 15.2835V14.4669H7.58366C7.23366 14.0002 6.88366 13.5335 6.76699 12.9502V12.8335H6.65033C6.53366 12.7169 6.41699 12.4835 6.41699 12.3669V11.4335C6.41699 11.3169 6.53366 11.0835 6.65033 10.9669L6.76699 10.8502V9.68353C6.76699 9.56686 6.88366 7.7002 9.33366 7.7002C11.667 7.7002 11.7837 9.68353 11.9003 9.68353V10.9669L12.017 11.0835C12.1337 11.2002 12.2503 11.3169 12.2503 11.5502V12.3669C11.9003 12.4835 11.9003 12.7169 11.667 12.8335V12.9502C11.4337 13.5335 11.2003 14.0002 10.7337 14.4669V15.2835C10.7337 15.5169 10.8503 15.8669 11.2003 15.9835L12.8337 17.0335C13.417 17.3835 13.767 17.9669 13.767 18.5502V18.7835C13.767 18.9002 13.6503 19.0169 13.5337 19.0169H4.90033Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 18.9C13.8833 18.9 13.7666 18.7833 13.7666 18.6667V18.4333C13.7666 17.7333 14.1166 17.15 14.6999 16.8L16.4499 15.6333C16.6833 15.5167 16.9166 15.1667 16.9166 14.9333V14.1167L16.7999 14C16.3333 13.5333 16.0999 13.0667 15.8666 12.4833V12.3667H15.7499C15.7499 12.25 15.6333 12.0167 15.6333 11.9V10.9667C15.6333 10.85 15.7499 10.6167 15.8666 10.5L15.9833 10.3833V9.1C15.8666 9.1 16.0999 7 18.5499 7C20.9999 7 21.2333 8.98333 21.2333 9.1V10.3833V10.5C21.3499 10.6167 21.4666 10.7333 21.4666 10.9667V11.9C21.4666 12.1333 21.3499 12.25 21.2333 12.4833H21.1166V12.6C20.9999 13.1833 20.6499 13.7667 20.1833 14.1167L20.0666 14.2333V15.05C20.0666 15.4 20.2999 15.6333 20.5333 15.75L22.2833 16.9167C22.9833 17.15 23.3333 17.7333 23.3333 18.4333V18.6667C23.3333 18.7833 23.2166 18.9 23.0999 18.9H13.9999Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51699 21.5834C8.28366 21.5834 8.16699 21.4667 8.16699 21.2334V21C8.16699 20.1834 8.63366 19.4834 9.33366 19.0167L11.4337 17.6167C11.9003 17.5 12.017 17.15 12.017 16.8V15.8667V15.75C11.4337 15.1667 11.0837 14.5834 10.8503 13.8834V13.7667L10.7337 13.65C10.617 13.5334 10.5003 13.3 10.5003 13.0667V11.9C10.5003 11.6667 10.5003 11.55 10.7337 11.4334L10.8503 11.3167V9.68337C10.8503 9.5667 11.0837 7.1167 14.117 7.1167C17.1503 7.1167 17.3837 9.5667 17.3837 9.68337V11.3167L17.5003 11.4334C17.5003 11.55 17.5003 11.6667 17.5003 11.9V13.0667C17.5003 13.3 17.3837 13.5334 17.1503 13.65L17.0337 13.7667V13.8834C16.917 14.5834 16.567 15.1667 15.9837 15.75V15.8667V16.9167C15.9837 17.2667 16.217 17.6167 16.567 17.85L18.667 19.25C19.367 19.6 19.8337 20.4167 19.8337 21.2334V21.4667C19.8337 21.7 19.717 21.8167 19.4837 21.8167H8.51699V21.5834Z",
    fill: "url(#paint2_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -1,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 12.9359,
    y1: 8.01473,
    x2: 6.96917,
    y2: 21.3432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 21.811,
    y1: 8.89642,
    x2: 16.038,
    y2: 21.7598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B82A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.7182,
    y1: 9.4078,
    x2: 9.34194,
    y2: 25.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 14.5833,
    fill: "white",
    transform: "translate(4.66699 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Group.898e1ce5.svg";
export { ForwardRef as ReactComponent };